/** SystemTaskCompletionDto */
export interface SystemTaskCompletion {
  systemTaskId: string;
  parameters: any[];
  output: any[];
}
